// import PropTypes from "prop-types";
import React, { FC } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaAngleLeft } from "react-icons/fa";
import { useTranslation } from "react-i18next";

interface PropType {
  pageTitle: string;
  prevUrl?: string;
}

const Breadcrumb: FC<PropType> = ({ pageTitle, prevUrl }) => {
  const history = useNavigate();
  const { t, i18n } = useTranslation();
  const goBack = () => {
    history(-1); // Navigate back
  };

  return (
    <div className="breadcrumb-area space-y--15">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-3">
            {
              prevUrl && (
                <Link
                  to={process.env.PUBLIC_URL + prevUrl}
                  className="back-link"
                >
                  {" "}
                  <FaAngleLeft /> {t("back")}
                </Link>
              )
              //     : (
              //   <a className="back-link" onClick={goBack}>
              //     {" "}
              //     <FaAngleLeft /> {t("back")}
              //   </a>
              // )
            }
          </div>
          <div className="col-6">
            <h4 className="page-title text-center text-white">{pageTitle}</h4>
          </div>
        </div>
      </div>
    </div>
  );
};

// Breadcrumb.propTypes = {
//   pageTitle: PropTypes.string,
//   prevUrl: PropTypes.string
// };

export default Breadcrumb;
